import React, { useContext, useEffect, useState } from 'react';
import { AddressForm } from 'src/pages/AccountPage/components/AddressForm/AddressForm';
import { ManagedFlexModal } from '@riac/design-system';
import { blankAddressForm } from 'src/pages/AccountPage/AddressBook/AddressBook';
import { AccountPagesContext } from 'src/lib/AccountPagesContext';

export const AddAddressModal = ({ onConfirm, onReject }) => {
  const [formAction, setFormAction] = useState('create');
  const {getStates, getCountries} = useContext(AccountPagesContext);
  const newAddress = Object.assign({}, blankAddressForm);
  newAddress.AddressType = 'Primary';
  newAddress.AddressTypeID = 1;

  useEffect(() => {
    getStates();
    getCountries();
  }, []);

  useEffect(() => {
    if(formAction === 'done') {
      onConfirm(true);
    }
    if(formAction === null) {
      onReject(false);
    }
  }, [formAction]);
  return (<ManagedFlexModal
    isOpen={true}
    title={'Create New Address'}
    onClose={() => onReject(false)}
    showCloseButton
    isDismissable
  >
    <div style={{ width: '100%', maxWidth: '540px', maxHeight: '750px' }}>
      <h5 className='my-4 text-red-700'>An Address is required for RIAC on Time</h5>
      <AddressForm
        formData={newAddress}
        addressTypeList={[]}
        setFormAction={setFormAction}
        formAction={formAction}
        addresses={[]}
      />
    </div>
  </ManagedFlexModal>);
};
